<template name="Training">
  <div class="page-training">
    <Top :isDetailPage="false" :trainingId="routeId" @changeVisitListStatus="inviteListShow = true"></Top>
    <main class="main-container container">
      <!-- show info now:  -->
      <h1 class="page-title">
        {{$t('TrainingList')}}
        <i class="iconfont icon-close" @click="goBackToDetail"></i>
      </h1>
      <div class="rule-translation">
        <h2 class="section-title">{{$t('followingTrainTest')}}</h2>
      </div>
      <div class="no-list" v-if="!this.lesson.length" v-show="!this.isLoading">
        <div class="inner">
        </div>
      </div>
      <div class="data-list" v-else>
        <section v-for="(item, index) in this.lesson">
          <div class="section-header row">
            <h2 class="section-title col-8" :data-id="item.categoryId">{{item.categoryName}}</h2>
            <div class="col-4 training-status" :class="item.lessonLearnStatus === 1 ? 'highlight' : ''"><i class="iconfont icon-hot"></i>{{item.lessonLearnStatusDesc}}</div>
          </div>
          <div class="section-content">
            <ul class="row">
              <li class="lesson" v-for="(lesson, lessonIndex) in item.lessonsModel">
                <div class="inner" :data-id="lesson.lessonId" :data-status="item.lessonLearnStatus" @click="checkIfTraining(lesson.lessonId)">
                  <div class="row">
                    <div class="col-4">
                      <img :src="lesson.lessonPhoto">
                    </div>
                    <div class="col-8">
                      <div class="title">{{lesson.lessonName}}</div>
                      <div class="status" :class="lesson.lessonPassStatus === 1 ? 'highlight' : ''"><i class="iconfont icon-clock"></i>{{lesson.lessonPassStatusDesc}}</div>
                    </div>
                  </div>
                  <i class="iconfont icon-right"></i>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </main>
    <footerMenuExternal :trainingId="routeId" :isContactSelectShow="false" :isDetailPage="false" @changeVisitListStatus="inviteListShow = true"></footerMenuExternal>
    <footerExternal :isLoginPage="false"></footerExternal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <transition name="fade">
      <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTitle" @cancel="closeModal"></alertModal>
    </transition>
  </div>
</template>

<script>
import Top from '@/views/external/top.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import alertModal from '@/components/alertModal.vue';

import { checkNested } from '@/utils/utils';
import { getExternalLessonList, getExternalLessonDetail } from '@/utils/api';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Training',
  components: {
    Top,
    footerExternal,
    footerMenuExternal,
    Loading,
    alertModal,
  },
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routeId: 0,
      categoryId: 0,
      lesson: [],
      modalTip: false,
      modalTitle: '',
      goback: false
    }
  },
  created() {
    this.routeId = this.$route.params.id;
    this.categoryId = this.$route.params.categoryId;

    this.getLesson();
  },
  watch: {
    $route() {
      this.routeId = this.$route.params.id;
      this.categoryId = this.$route.params.categoryId;

      this.getLesson();
    },
  },
  methods: {
    getLesson() {
      this.isLoading = true;
      getExternalLessonList(this.routeId, this.categoryId).then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          this.lesson = res.data.content.model;
          if (this.lesson.length === 0) {
            this.modalTip = true;
            this.modalTitle = this.$t('noTrainingCourse');
            this.goback = true;
          }
        }
      });
    },
    checkIfTraining(currentLessonId) {
      // 19-05-16, Change made by Andy: check if can get into detail page
      const ticketId = this.routeId;
      const lessonId = currentLessonId;
      getExternalLessonDetail(ticketId, lessonId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          const { status, message } = res.data.content;
          if (status === 1) {
            this.$router.push({
              path: `/external/trainingDetail/${ticketId}/${lessonId}`,
            });
          } else {
            this.modalTip = true;
            this.modalTitle = message;
            this.goback = false;
          }
        }
      });
    },
    closeModal() {
      return this.goback ? this.$router.go(-1) : this.modalTip = false;
    },
    goBackToDetail() {
      const ticketId = this.routeId;
      this.$router.push({
        path: `/external/detailIndex/${ticketId}/0`,
      });
    },
  },
};
</script>
<style lang="scss">
.page-training {
  color: #4a4a4a;
  .detail-header {
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    margin: 0 -500%;
    padding: 0 500%;
    z-index: 12;
  }
  main {
    padding: 20px 0;
  }
  .detail-header .row .header-right .two-link .training {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 3px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e42029;
    }
    span,
    i {
      color: #e42029;
    }
  }
}
</style>
<style scoped lang="scss">
@import '../../scss/variables.scss';
.modal-open {
  .common-modal {
    position: fixed;
  }
}
.page-training {
  color: #4a4a4a;
  .page-title  {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .rule-translation {
    h2.section-title {
      font-size: 12px;
      color: #929292;
    }
  }
  .section-header {
    margin-bottom: 20px;
    margin-top: 5px;
    line-height: 18px;
    @include respond-to('sm-max') {
      margin-bottom: 15px;
    }
  }
  .section-title {
    font-size: 14px;
    margin-bottom: 0;
    line-height: 18px;
  }
  .main-container {
    padding: 0 15px 90px;
    margin-top: 30px;
    min-height: calc(100vh - 140px);
  }
  .training-status {
    color: #4a4a4a;
    font-size: 13px;
    text-align: right;
    i {
      margin-right: 2px;
      color: #d0d0d0;
    }
    &.highlight {
      i {
        color: #f36443;
      }
    }
  }
}
.data-list {
  ul {
    padding: 0;
    list-style: none;
    &.row {
      margin: 0;
      justify-content: space-between;
    }
  }
  li {
    width: 43%;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(100, 100, 100, 0.15);
    padding: 20px;
    img {
      width: 100%;
      border-radius: 4px;
      height: auto;
    }
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 1.5;
      height: 21px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #4a4a4a;
      padding-right: 15px;
    }
    .status {
      font-size: 12px;
      color: #929292;
      position: absolute;
      bottom: 0;
      &.highlight {
        color: #e42029;
      }
      i {
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .col-4 {
      min-height: 44px;
    }
    .col-8 {
      padding-left: 0;
    }
    @include respond-to('sm-max') {
      width: 100%;
      padding: 12px;
    }
    @include respond-to('ml') {
      width: 100%;
    }
  }
  .inner {
    position: relative;
    cursor: pointer;
    .icon-right {
      position: absolute;
      right: 0;
      top: 50%;
      font-size: 12px;
      ;border-image-width: 1;
      margin-top: -6px;
      color: #4a4a4a;
    }
  }
}
</style>
